// Fire-and-forget client for the unified student-activity tracker.
// Used by all login-gated simulators. Silently no-ops if user isn't logged in.

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/activity`;

export const getLoggedInEmail = () => {
  try {
    return (localStorage.getItem('practiq_portal_email') || '').trim().toLowerCase();
  } catch (_) {
    return '';
  }
};

export const trackActivity = async ({ simulator_id, simulator_name, action, score, metadata }) => {
  const email = getLoggedInEmail();
  if (!email || !simulator_id || !simulator_name || !action) return false;
  try {
    await fetch(`${API_BASE}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, simulator_id, simulator_name, action, score, metadata }),
      keepalive: true, // so events still fire on page navigation
    });
    return true;
  } catch (_) {
    // best-effort; never block UX
    return false;
  }
};

export const fetchMyActivity = async () => {
  const email = getLoggedInEmail();
  if (!email) return null;
  try {
    const res = await fetch(`${API_BASE}/my-activity?email=${encodeURIComponent(email)}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (_) {
    return null;
  }
};
